const state = {
  mailRoom: JSON.parse(localStorage.getItem('mailRoom')),
  viewNewMailChatFlg: JSON.parse(localStorage.getItem('viewNewMailChatFlg'))
}

const mutations = {
  onUpdateCurrentMailRoom (state, mailRoom) {
    state.mailRoom = mailRoom
    localStorage.setItem('mailRoom', JSON.stringify(mailRoom))
  },
  onUpdateViewNewMailChatFlg (state, reload) {
    state.viewNewMailChatFlg = reload
    localStorage.setItem('viewNewMailChatFlg', JSON.stringify(reload))
  }
}

const actions = {
  setCurrentMailRoom (context, mailRoom) {
    let newMailRoom = !mailRoom ? null : {
      id: mailRoom.roomId,
      accessToken: mailRoom.roomAccessToken
    }
    context.commit('onUpdateCurrentMailRoom', newMailRoom)
  },
  setviewNewMailChatFlg (context, reload) {
    context.commit('onUpdateViewNewMailChatFlg', reload)
  }
}

const getters = {
  currentMailRoom: state => state.mailRoom,
  chatEnabled: state => state.chatEnabled,
  viewNewMailChatFlg: state => state.viewNewMailChatFlg
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/mailRoom.js